export enum PricingStructure {
  monthly = 'monthly',
  instalment = 'instalment',
}

export enum FeeMode {
  regular = 'regular',
  promotional = 'promotional',
  nofee = 'nofee',
}
